import React from 'react';
import PropTypes from 'prop-types';
import { Link, Divider, Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ActionLinksRow = _ref => {
  let {
    links,
    includeDivider = true,
    themeGroup
  } = _ref;
  const theme = useTheme();

  // eslint-disable-next-line react/prop-types
  if (!links || links.length === 0) {
    return null;
  }
  const {
    actionLinkRow
  } = theme;
  const alr = (themeGroup === null || themeGroup === void 0 ? void 0 : themeGroup.actionLinkRow) || actionLinkRow;
  const renderLinksRow = () => {
    const lCount = links.length;
    return links.map((link, index) => {
      const {
        label,
        url,
        target
      } = link;
      if (index === lCount - 1) {
        return /*#__PURE__*/_jsx(Link, {
          sx: alr,
          marginLeft: "3px",
          href: url,
          target: target,
          rel: "noopener noreferrer",
          children: label
        }, index);
      }
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(Link, {
          sx: alr,
          href: url,
          target: "_blank",
          rel: "noopener noreferrer",
          children: label
        }, index), /*#__PURE__*/_jsx("span", {
          children: " | "
        })]
      });
    });
  };
  const renderDivider = includeDivider => {
    if (includeDivider) {
      return /*#__PURE__*/_jsx(Divider, {});
    }
    return null;
  };
  return /*#__PURE__*/_jsxs(React.Fragment, {
    children: [renderDivider(includeDivider), /*#__PURE__*/_jsx(Box, {
      sx: alr,
      children: renderLinksRow()
    })]
  });
};
ActionLinksRow.propTypes = {
  links: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    url: PropTypes.string,
    target: PropTypes.oneOf(['_blank', '_self', '_parent', '_top'])
  })),
  includeDivider: PropTypes.bool,
  themeGroup: PropTypes.object
};
export default ActionLinksRow;